import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Row, Col, Button, DatePicker, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { setFilters } from "../balanceSheetSlice";
import { fetchBalanceSheet } from "../balanceSheetThunk";
import SearchListAutoComplete from "../../../../components/SearchListAutoComplete";
import dayjs from "dayjs";
import { currentDateEndTime, currentDateEndTime2, dateTimeFormat, toCompanyDateOnlyforReportDateFilter } from "../../../../lib/functions";
import Swal from "sweetalert2";
import { useDefaultDateRange } from "../../../../hooks/useDefaultDateRange";
import useMigrationDate from "../../../../hooks/useMigrationDate";

const BalanceSheetFilters = ({ messageApi }) => {
  const dispatch = useDispatch();
  const { filters } = useSelector((state) => state.balanceSheet);
  const { disabledDate } = useMigrationDate();

  useDefaultDateRange(setFilters, filters, "today");

  const handleFilterChange = (field, value) => {
    dispatch(setFilters({ [field]: value }));
  };

  const handleReport = () => {
    dispatch(fetchBalanceSheet({ filters })).then((res) => {
      if (res.meta.requestStatus === "fulfilled") {
        messageApi.success("Report loaded ✅");
      }
    });
  };

  return (
    <Card className="product-replace-filters mb-4 shadow-md rounded-xl">
      <Row
        gutter={[16, 16]}
        align="middle"
        wrap        
      >
 <Col xs={24} sm={12} md={4}>
        <label>Filter Type</label>
        <Select
          style={{ width: "100%" }}
          placeholder="Filter Type"
          value={filters.filterType || undefined}
          onChange={(value) => handleFilterChange("filterType", value)}
          options={[
            { label: "Life Time", value: "Life Time" },
            { label: "Date Wise", value: "Date Wise" },
                { label: "Financial Year", value: "Financial Year" }, // ✅ ADD
          ]}
        />
      </Col>
{filters.filterType === "Financial Year" && (
  <Col xs={24} sm={12} md={12} lg={8} xl={6}>
    <label>Select Financial Year</label>
    <DatePicker
      picker="year"
      style={{ width: "100%" }}
      value={filters.fyYear ? dayjs().year(filters.fyYear) : null}
      onChange={(v) => {
        if (!v) {
          handleFilterChange("fyYear", null);
          return;
        }
        handleFilterChange("fyYear", v.year());
      }}
    />
  </Col>
)}
        {filters.filterType === "Date Wise" ? (
          <Col xs={24} sm={12} md={12} lg={8} xl={6}>
            <label className="form-label-nowrap">
              <span style={{ color: "#ff4d4f" }}>*</span> To Date
            </label>
            <DatePicker
              size="large"
              value={
                filters.toDate
                  ? toCompanyDateOnlyforReportDateFilter(filters.toDate)
                  : null
              }
              data-testid="to-datepicker"
              onChange={(v) => {
                if (!v) {
                  handleFilterChange("toDate", null);
                  return;
                }
                const isoEnd = currentDateEndTime2(v);
                // if (
                //   filters.fromDate &&
                //   dayjs(isoEnd).isBefore(dayjs(filters.fromDate))
                // ) {
                //   Swal.fire({
                //     icon: "warning",
                //     title: "Invalid Date",
                //     text: "To Date cannot be before From Date.",
                //     confirmButtonColor: "#1677ff",
                //   });
                //   return;
                // }
                handleFilterChange("toDate", isoEnd);
              }}
              style={{ width: "100%" }}
              format={dateTimeFormat}
              disabledDate={disabledDate}
            />
          </Col>
        ) : (
          ""
        )}

        <Col
          xs={24}
          sm={12}
          md={4}
          style={{ display: "flex", alignItems: "flex-end", height: 58 }}
        >
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleReport}
            block
            style={{height: 35.19}}
            data-testid="report-btn"
          >
            Report
          </Button>
        </Col>
      </Row>
      <style>{`
     @media (min-width: 768px) and (max-width: 1024px) {
      .product-replace-filters .ant-row .ant-col {
        flex: 0 0 50% !important;
        max-width: 50% !important;
      }
     }     
    `}</style>
    </Card>
  );
};

export default BalanceSheetFilters;
